import { render, staticRenderFns } from "./EditTraining.vue?vue&type=template&id=212f20dd"
import script from "./EditTraining.vue?vue&type=script&lang=js"
export * from "./EditTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports